import React from "react";
import { getCustomHeadingsLabel, headingsMap, translateHeading } from "../heading";
const getCurrentHeadingIcon = (allowHeadingCustomization) => (publicCommands, t) => {
  const selectedHeading = publicCommands.getCurrentHeading();
  let Label;
  if (allowHeadingCustomization) {
    Label = getCustomHeadingsLabel(selectedHeading, t, publicCommands);
  } else {
    Label = translateHeading(headingsMap[selectedHeading], t);
  }
  return () => /* @__PURE__ */ React.createElement("div", null, Label);
};
export {
  getCurrentHeadingIcon
};
//# sourceMappingURL=getCurrentHeadingIcon.js.map
